import { render, staticRenderFns } from "./main-review-card.vue?vue&type=template&id=90fab8e4&scoped=true"
import script from "./main-review-card.vue?vue&type=script&lang=js"
export * from "./main-review-card.vue?vue&type=script&lang=js"
import style0 from "./main-review-card.vue?vue&type=style&index=0&id=90fab8e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fab8e4",
  null
  
)

export default component.exports